module.exports = __webpack_public_path__ + "static/img/boron-3.5c816cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/boron-3.jpg
// module id = w/RW
// module chunks = 1